import Action from '../../../decorators/Action';
import Observable from '../../../decorators/Observable';
import StoreFieldInSession from '../../../decorators/StoreFieldInSession';
import AbstractSessionModel from '../../../models/AbstractSessionModel';

export default class SocialMediaWizardDataModel extends AbstractSessionModel {
  @Observable()
  @StoreFieldInSession()
  public business_url_facebook = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_instagram = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_pinterest = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_linkedin = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_tiktok = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_x = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_xing = '';

  @Observable()
  @StoreFieldInSession()
  public business_url_youtube = '';

  constructor() {
    super();
    super.initFields();
  }

  @Action()
  setFormData(formData: {
    business_url_facebook?: string;
    business_url_instagram?: string;
    business_url_pinterest?: string;
    business_url_linkedin?: string;
    business_url_tiktok?: string;
    business_url_x?: string;
    business_url_xing?: string;
    business_url_youtube?: string;
  }) {
    this.business_url_facebook = formData.business_url_facebook;
    this.business_url_instagram = formData.business_url_instagram;
    this.business_url_pinterest = formData.business_url_pinterest;
    this.business_url_linkedin = formData.business_url_linkedin;
    this.business_url_tiktok = formData.business_url_tiktok;
    this.business_url_x = formData.business_url_x;
    this.business_url_xing = formData.business_url_xing;
    this.business_url_youtube = formData.business_url_youtube;
  }

  getWizardData() {
    return {
      business_url_facebook: this.business_url_facebook,
      business_url_instagram: this.business_url_instagram,
      business_url_pinterest: this.business_url_pinterest,
      business_url_linkedin: this.business_url_linkedin,
      business_url_tiktok: this.business_url_tiktok,
      business_url_x: this.business_url_x,
      business_url_xing: this.business_url_xing,
      business_url_youtube: this.business_url_youtube
    };
  }

  public getSessionKey() {
    return 'SocialMediaWizardDataModel';
  }
}
